"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.agentStatusTranslations = {
    "en": {
        ready: "Ready",
        onphone: "On phone",
        busy: "Other queue busy",
        wrapup: "Wrap up",
        idle: "Idle",
        calling: "Ringing",
        loggedout: "Logged out",
        status: "Status",
        agent: "Agent",
        lastLoggedIn: "Last logged in",
        lastLoggedOut: "Last logged out",
        agentStatus: "Agent Status",
    },
    "de": {
        wrapup: "Abschließen",
        agent: "Mitarbeiter",
        idle: "Inaktiv",
        lastLoggedOut: "Zuletzt ausgeloggt",
        loggedout: "Ausgeloggt",
        onphone: "Am Telefon",
        agentStatus: "Mitarbeiterstatus",
        ready: "Bereit",
        busy: "Andere Warteschlange besetzt",
        calling: "Läutet",
        lastLoggedIn: "Zuletzt eingeloggt",
        status: "Status",
    },
    "nl": {
        wrapup: "Afronden",
        agent: "Agent",
        idle: "Niet bezet",
        lastLoggedOut: "Laatst uitgelogd",
        loggedout: "Uitgelogd",
        onphone: "Verbonden",
        agentStatus: "Agentstatus",
        ready: "Klaar",
        busy: "Andere rij bezig",
        calling: "Bellen",
        lastLoggedIn: "Laatst ingelogd",
        status: "Status",
    },
    "it": {
        wrapup: "Concludere",
        agent: "Agente",
        idle: "Inattivo",
        lastLoggedOut: "Ultima disconnessione",
        loggedout: "Disconnesso",
        onphone: "Al telefono",
        agentStatus: "Stato agente",
        ready: "Disponibile",
        busy: "Occupato in un altra coda",
        calling: "Sta suonando",
        lastLoggedIn: "Ultimo accesso",
        status: "Stato",
    },
    "fr": {
        wrapup: "Conclure",
        agent: "Agent",
        idle: "Inactif",
        lastLoggedOut: "Dernière déconnexion",
        loggedout: "Déconnecté",
        onphone: "En appel",
        agentStatus: "Statut de l'agent",
        ready: "Prêt",
        busy: "Autre file d'attente occupée",
        calling: "Sonnerie",
        lastLoggedIn: "Dernière connexion",
        status: "Statut",
    },
    "es": {
        wrapup: "Concluir",
        agent: "Agente",
        idle: "Inactivo",
        lastLoggedOut: "Última vez que finalizó sesión o se desconectó",
        loggedout: "Sesión cerrada",
        onphone: "Al teléfono",
        agentStatus: "Estado del agente",
        ready: "Listo",
        busy: "La otra cola de espera esta ocupada",
        calling: "Sonando",
        lastLoggedIn: "Última vez que inició sesión o se conectó",
        status: "Estado",
    },
    "ja": {
        wrapup: "ラップアップ",
        agent: "エージェント",
        idle: "不稼働",
        lastLoggedOut: "最近のログアウト",
        loggedout: "ログアウト済み",
        onphone: "電話中",
        agentStatus: "エージェントステータス",
        ready: "応答可能",
        busy: "他のキューが使用中",
        calling: "呼び出し中",
        lastLoggedIn: "最近のログイン",
        status: "ステータス",
    },
    "en-GB": {
        wrapup: "Wrap up",
        agent: "Agent",
        idle: "Idle",
        lastLoggedOut: "Last logged out",
        loggedout: "Logged out",
        onphone: "On phone",
        agentStatus: "Agent Status",
        ready: "Ready",
        busy: "Other queue busy",
        calling: "Ringing",
        lastLoggedIn: "Last logged in",
        status: "Status",
    },
    "ru": {
        ready: "Готов",
        onphone: "На телефоне",
        busy: "Временно не доступен",
        wrapup: "Завершает звонок",
        idle: "Не доступен",
        calling: "Звонит",
        loggedout: "Не в сети",
        status: "Статус",
        agent: "Агент",
        lastLoggedIn: "Последний вход",
        lastLoggedOut: "Последний выход",
        agentStatus: "Статус Агента",
    },
};
